<template>
  <div class="container ">

      <div class="card" >
    <!--<img src="..." class="card-img-top" alt="...">-->
    <div class="card-body">
        <h5 class="card-title">Agregar Visitante</h5>
        <form class="text-left">
            <div class="form-group">
                <label class='etiquetaLabel' for="fecha">Fecha</label><br/>
                <input type="date" class="etiqueta" v-model='fechaing' >  
            </div>
            <div class="form-group">
                <label class='etiquetaLabel' for="rut">Rut</label><br/>
                <input type="text" class="etiqueta" v-model='rut' readonly maxlength="9" minlength="9" size="9">  
            </div>

            <div class="form-group">
                <label class='etiquetaLabel' for="tipo">Seleccione</label><br/>
                <select v-model="residente" @change.prevent="reside" class="etiqueta">
                    <option disabled value="">Seleccione</option>
                    <option>Visitante</option>
                    <option>Servicios</option>
                    <option>Delivery</option>
                </select>
            </div>
            
            <div class="form-group">
                <label class='etiquetaLabel' for="numerodepartamento">Depto</label><br/>
                <input id='numerodepartamento' type="number" class="etiqueta" v-model.number="numerodepartamento" min='1' max="2299"  size="4" maxlength="4">           
            </div>
            <div class="form-group">
                <label class='etiquetaLabel' for="nombre">Nombre</label>
                <input id='nombre' type="text" class="etiqueta" v-model="nombre" size="15" maxlength="20" >           
            </div>
            <div class="my-5">
                    <button type="button" class="btn btn-primary btn-block my-3" @click.prevent="savePersona">Save </button>
                    <button type="button" class="btn btn-secondary btn-block my-3" @click.prevent="volver"  >Close</button>
            </div>

        </form>
  </div>
</div>



         
      
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    name:'CarAdd',
    data(){
        return{            
            fecha: new Date(),
            fechaing:'',
            residente:'Visitante',
            nombre:'',
            numerodepartamento:9999,
            patente: ''
        }
    },
    computed:{
        
    },
    created(){
        this.rut = this.$route.params.id;
        this.fechaing= this.fecha.getDate() + '/' + (this.fecha.getMonth() + 1) + '/' + this.fecha.getFullYear();
    },
    methods:{
        volver(){
            this.$router.push('/');
        },
        reside(){    
            if(this.residente==='Servicios'){
                this.nombre='Servicios';
                this.numerodepartamento=''
                document.getElementById("numerodepartamento").focus();
            } else if(this.residente==='Delivery'){
                this.nombre='Delivery';
                this.numerodepartamento=''
                document.getElementById("numerodepartamento").focus();
            }else {
                this.nombre=''                
                this.numerodepartamento=''
                document.getElementById("numerodepartamento").focus();
            }
        },
        savePersona(){
            console.log("entramos a grabar ")
            if(this.numerodepartamento && this.residente && this.nombre){
                let auxiliar={
                    fechaing:this.fecha,
                    rut:this.rut.toUpperCase(),
                    residente:this.residente.toUpperCase(),
                    numerodepartamento:this.numerodepartamento,
                    nombre:this.nombre.toUpperCase(),
                }
                this.$store.dispatch('savePersona',auxiliar);                                 
                this.$router.push('/personas');
            }else{
                Swal.fire("Escriba datos")                 
            }
            this.residente='Visitante';
            this.numerodepartamento=9999;
            this.nombre='';

        }
    }
}
</script>

<style scoped>


</style>